<template>
  <div class="aside">
    <div class="list-group list-group-root well ml-0">

      <li
        is="GroupOnlyButton"
        v-for="(group, index) in groups"
        v-bind:key="$filters.cleanId(group.id)"
        v-bind:index="index"
        v-bind:name=group.name
        v-bind:group=group
      ></li>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import GroupOnlyButton from './GroupOnlyButton.vue'
Vue.use(GroupOnlyButton)
export default {
  name: 'AsideGroupList',
  props: {
    msg: String
  },
  components: {
    GroupOnlyButton
  },
  data() {
    return {
      show_list: true,
      groups_: [
        {
            id: 1,
            name: "Group1",
            is_group: false,
        },
        {
            id: 2,
            name: "Group2",
            is_group: false,
        },
        {
            id: 3,
            name: "Group2",
            is_group: false,
        },
        {
            id: 4,
            name: "Group2",
            is_group: false,
        },
      ]
    }
  },
  methods: {
    switchGroup(group) {
      this.$store.commit('switch_group', group)
      this.$store.dispatch('loadGroupData')
      
    },
  },
  computed: {
    groups() {
      if (this.$store.state.group_list) {
          // eslint-disable-next-line
          console.log("Groups: ");
          // eslint-disable-next-line
          console.log(this.$store.state.group_list);
          return this.$store.state.group_list.groups
      } else {
          return this.groups_
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .aside {
    overflow-y: auto;
    max-height: 100%;
  }
</style>
